import React from 'react';
import PropTypes from 'prop-types';

const ThumbsUp = ({ fill, className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="14.46"
    height="15.26"
    viewBox="0 0 14.46 15.26"
    className={className}
  >
    <path
      d="M1.13-2.069C1.13.362,2.653,2.3,4.786,2.3H6.862a6.9,6.9,0,0,0,3,.66h.9a9.3,9.3,0,0,0,2.095-.178A2.039,2.039,0,0,0,14.549.838,1.3,1.3,0,0,0,14.5.482,1.937,1.937,0,0,0,15.177-.99a1.966,1.966,0,0,0-.121-.686,1.978,1.978,0,0,0,.451-1.276,1.92,1.92,0,0,0-.2-.863,2.152,2.152,0,0,0,.279-1.1,1.919,1.919,0,0,0-1.961-1.974H11.35c-.1,0-.171-.051-.159-.159.1-.6,1.035-2.095,1.035-3.383A1.8,1.8,0,0,0,10.41-12.3c-.755,0-1.289.4-1.765,1.314a27.771,27.771,0,0,1-3.1,4.52h-1C2.533-6.468,1.13-4.539,1.13-2.069Zm4.431-.083A4.841,4.841,0,0,1,6.7-5.434,31.3,31.3,0,0,0,10-10.251c.133-.267.229-.336.381-.336.178,0,.292.133.292.349,0,.781-1.066,2.38-1.066,3.472a1.462,1.462,0,0,0,1.631,1.428h2.311a.467.467,0,0,1,.489.476.647.647,0,0,1-.222.489.711.711,0,0,0-.063.965.725.725,0,0,1,.2.463.593.593,0,0,1-.279.482.781.781,0,0,0-.248,1,.868.868,0,0,1,.146.444c0,.235-.146.419-.438.578a.712.712,0,0,0-.279.9.688.688,0,0,1,.1.362c0,.2-.152.375-.508.463a8.2,8.2,0,0,1-1.866.121l-.7-.006C7.3,1.371,5.561-.051,5.561-2.152Zm-2.926.083c0-1.555.724-2.761,1.625-2.875.114-.006.229-.006.343-.013a6.33,6.33,0,0,0-.6,2.837A4.643,4.643,0,0,0,5.059.87c-.146,0-.311-.006-.47-.013C3.5.736,2.634-.489,2.634-2.069Z"
      transform="translate(-1.13 12.302)"
      fill={fill}
    />
  </svg>
);

ThumbsUp.propTypes = {
  fill: PropTypes.string.isRequired,
  className: PropTypes.string,
};

export default ThumbsUp;
